const bs = {
  fieldPhotos: {
    camera: 'Fotografiši objekat', gallery: 'Fotografije objekta', title: 'Fotografije · {{customer}}',
    newPhoto: 'Nova fotografija', noPhotos: 'Još nema fotografija u ovoj posjeti.',
    optionalTags: 'Tagovi nisu obavezni.', chooseTags: 'Odaberi tagove', retake: 'Ponovi fotografisanje',
    discard: 'Odbaci', discardConfirm: 'Odbaciti fotografiju bez spremanja?', discardFailed: 'Fotografija nije odbačena. Pokušajte ponovo.', tags: 'Tagovi', saveOnClose: 'Fotografija se automatski čuva pri zatvaranju.',
    saved: 'Fotografija je sačuvana i čeka sinhronizaciju.', prepareFailed: 'Fotografiju nije moguće pripremiti.',
    saveFailed: 'Fotografija nije spremljena. Pokušajte ponovo.', accountChanged: 'Korisnik je promijenjen. Fotografisanje ponovite nakon prijave.',
    newAlt: 'Nova fotografija objekta', photoAlt: 'Fotografija objekta', sent: 'Poslano', pending: 'Čeka slanje', discarded: 'Odbačeno', failed: 'Slanje nije uspjelo',
    noTags: 'Tagovi trenutno nisu dostupni. Možete nastaviti bez njih.',
  },
  common: {
    active: 'Aktivno',
    all: 'Sve',
    amount: 'Iznos',
    and: 'i',
    appName: 'mSales',
    back: 'Nazad',
    barcode: 'Barkod',
    cancel: 'Otkaži',
    code: 'Šifra',
    comment: 'Komentar',
    confirm: 'Potvrdi',
    count: 'Broj',
    date: 'Datum',
    delete: 'Obriši',
    description: 'Opis',
    details: 'Detalji',
    document: 'Dokument',
    done: 'Završeno',
    edit: 'Uredi',
    empty: 'Prazno',
    error: 'Greška',
    filters: 'Filteri',
    from: 'Od',
    image: 'Slika',
    loading: 'Učitava...',
    name: 'Naziv',
    next: 'Dalje',
    no: 'Ne',
    noData: 'Nema podataka',
    noResults: 'Nema rezultata',
    note: 'Napomena',
    ok: 'U redu',
    optional: 'Opcionalno',
    operator: 'Operator',
    previous: 'Prethodno',
    quantity: 'Količina',
    refresh: 'Osvježi',
    required: 'Obavezno',
    reset: 'Resetuj',
    retry: 'Pokušaj ponovo',
    save: 'Sačuvaj',
    search: 'Pretraga',
    selected: 'Odabrano',
    send: 'Pošalji',
    status: 'Status',
    success: 'Uspješno',
    sync: 'Sinhronizacija',
    time: 'Vrijeme',
    to: 'Do',
    total: 'Ukupno',
    type: 'Tip',
    unknown: 'Nepoznato',
    undefined: 'Nedefinisano',
    upload: 'Pošalji fajl',
    value: 'Vrijednost',
    warning: 'Upozorenje',
    yes: 'Da',
    notAvailable: 'N/A',
  },
  actions: {
    add: 'Dodaj',
    addComment: 'Dodaj komentar',
    addImage: 'Dodaj sliku',
    addProduct: 'Dodaj artikal',
    approve: 'Odobri',
    change: 'Promijeni',
    clear: 'Očisti',
    clearAll: 'Očisti sve',
    close: 'Zatvori',
    continue: 'Nastavi',
    copy: 'Kopiraj',
    create: 'Kreiraj',
    download: 'Preuzmi',
    exit: 'Izađi',
    finish: 'Završi',
    goHome: 'Na početnu',
    open: 'Otvori',
    print: 'Štampaj',
    reject: 'Odbij',
    remove: 'Ukloni',
    repeat: 'Ponovi',
    restore: 'Vrati',
    select: 'Odaberi',
    selectAll: 'Odaberi sve',
    show: 'Prikaži',
    share: 'Podijeli',
    skip: 'Preskoči',
    submit: 'Pošalji',
    stop: 'Prekini',
    update: 'Ažuriraj',
  },
  navigation: {
    admin: 'Administracija',
    cart: 'Korpa',
    customers: 'Kupci',
    home: 'Početna',
    orders: 'Narudžbe',
    products: 'Artikli',
    reports: 'Izvještaji',
    tasks: 'Zadaci',
  },
  entities: {
    agent: 'Putnik',
    article: 'Artikal',
    brand: 'Brend',
    category: 'Robna grupa',
    customer: 'Kupac',
    deliveryLocation: 'Mjesto isporuke',
    document: 'Dokument',
    order: 'Narudžba',
    product: 'Artikal',
    route: 'Ruta',
    salesman: 'Komercijalista',
    survey: 'Anketa',
    task: 'Zadatak',
    user: 'Korisnik',
    visit: 'Posjeta',
  },
  statuses: {
    approved: 'Odobreno',
    blocked: 'Blokirano',
    canceled: 'Otkazano',
    completed: 'Završeno',
    failed: 'Neuspješno',
    inProgress: 'U toku',
    offline: 'Offline',
    online: 'Online',
    pending: 'Na čekanju',
    ready: 'Spremno',
    rejected: 'Odbijeno',
    saved: 'Sačuvano',
    sent: 'Poslano',
    synced: 'Sinhronizovano',
    unsynced: 'Nije sinhronizovano',
  },
  validation: {
    requiredField: 'Obavezno polje',
    customerRequired: 'Kupac je obavezan.',
    dateRequired: 'Datum je obavezan.',
    fieldRequired: 'Ovo polje je obavezno.',
    fillRequiredFields: 'Molimo popunite obavezna polja.',
    invalidEmail: 'Unesite ispravnu email adresu.',
    invalidNumber: 'Unesite ispravan broj.',
    locationRequired: 'Lokacija je obavezna.',
    productRequired: 'Odaberite artikal.',
    quantityRequired: 'Količina je obavezna.',
  },
  errors: {
    generic: 'Došlo je do greške. Pokušajte ponovo.',
    loadingData: 'Greška prilikom preuzimanja podataka.',
    network: 'Greška mreže. Provjerite internet vezu.',
    noInternet: 'Nema internet konekcije.',
    server: 'Greška na serveru. Pokušajte ponovo.',
    unauthorized: 'Niste ovlašteni za ovu akciju.',
    upload: 'Greška prilikom slanja fajla.',
  },
  dateRanges: {
    today: 'Danas',
    last7Days: 'Zadnjih 7 dana',
    thisMonth: 'Ovaj mjesec',
    thisYear: 'Ova godina',
    lastMonth: 'Prošli mjesec',
    dateFrom: 'Datum od',
    dateTo: 'Datum do',
    now: 'Sada',
  },
  weekdays: {
    full: {
      mon: 'Ponedjeljak',
      tue: 'Utorak',
      wed: 'Srijeda',
      thu: 'Četvrtak',
      fri: 'Petak',
      sat: 'Subota',
      sun: 'Nedjelja',
    },
    short: {
      mon: 'Pon',
      tue: 'Uto',
      wed: 'Sri',
      thu: 'Čet',
      fri: 'Pet',
      sat: 'Sub',
      sun: 'Ned',
    },
  },
  offline: {
    banner: 'Trenutno ste offline.',
    dataUnavailable: 'Podaci trenutno nisu dostupni offline.',
    manualMode: 'Ručni režim sinhronizacije je aktivan.',
    mode: 'Offline režim',
    orderSaved: 'Narudžba je sačuvana i biće poslana kada internet bude dostupan.',
    requiresInternet: 'Za ovu akciju potrebna je aktivna internet konekcija.',
  },
  sync: {
    title: 'Sinhronizacija',
    incomingTitle: 'Dolazna sinhronizacija',
    allSynced: 'Sve je sinhronizovano.',
    pendingOperations: 'Operacije na čekanju',
    restoreOperations: 'Vrati operacije',
    startSync: 'Pokreni sinhronizaciju',
    syncNow: 'Sinhronizuj',
    syncFailed: 'Sinhronizacija nije uspjela.',
    syncInProgress: 'Sinhronizacija je u toku.',
    syncSuccess: 'Sinhronizacija je uspješno završena.',
    priceReview: {
      pending: '{{count}} narudžbi čeka cijene',
      pendingHint: 'Učitajte cijene da ih pregledate i pošaljete.',
      loaded: '{{count}} narudžbi, cijene učitane',
      loadedHint: 'Cijene i rabati se primjenjuju pri slanju.',
      noneReady: 'Nijedna narudžba nema artikle s cijenom.',
      loadAll: 'Učitaj cijene za sve',
      loadOne: 'Učitaj cijene',
      loadOffline: 'Učitajte cijene kada budete online.',
      loadFailed: '{{count}} narudžbi nije uspjelo učitati cijene.',
      sendAll: 'Potvrdi i pošalji sve ({{count}})',
      dropWarn: '{{items}} artikala u {{orders}} narudžbe nema cijenu i neće biti poslano.',
      reviewTitle: 'Pregledaj pojedinačno',
      ready: 'Spremno',
      waiting: 'Čeka cijene',
      itemCount: '{{count}} art.',
      droppedItems: '{{count}} artikala nema cijenu i neće biti poslano',
      itemNoPrice: 'nema cijenu, neće biti poslano',
      editItems: 'Izmijeni količine',
      total: 'Ukupno',
      confirmOrder: 'Potvrdi i pošalji',
      remove: 'Ukloni',
      confirmed: 'Narudžba potvrđena.',
      sendAllTitle: 'Poslati sve narudžbe?',
      sendAllComplete: '{{count}} narudžbi će biti poslano.',
      sendAllDropped: '{{orders}} narudžbe imaju ukupno {{items}} artikala bez cijene. Ti artikli neće biti poslani.',
      sendConfirm: 'Pošalji sve',
      review: 'Pregledaj',
      noPrice: 'Bez cijene',
    },
    orderAgeWarning: 'Ova narudžba čeka {{days}} dana. Sinhronizujte što prije.',
    orderRemovedFromQueue: 'Narudžba {{id}} je uklonjena iz reda čekanja.',
    offlinePriceNotice: 'Offline: cijene su okvirne, konačne cijene i rabati primjenjuju se pri slanju.',
    priceRefreshFailed: 'Cijene nije moguće osvježiti. PDF koristi lokalno sačuvane cijene.',
  },
  home: {
    title: 'Početna',
    approvals: 'Odobrenja',
    continueWithCustomer: 'Nastavi sa ovim kupcem →',
    dailyRoute: 'Dnevna ruta',
    finishDay: 'Završi dan',
    finishDayConfirmBody: 'Nećete moći unositi nove narudžbe niti obavljati druge aktivnosti. Sve preostalo ćete morati uraditi sutra.',
    finishDayConfirmTitle: 'Nećete moći ponovo započeti rad za danas. Nastaviti?',
    finishDayPendingSyncWarning: 'Nije moguće završiti dan dok ima {{count}} operacija na čekanju. Sinhronizirajte podatke klikom na WiFi ikonu u gornjem desnom uglu.',
    helperTitle: 'Trebate li pomoć oko narudžbi?',
    helperModalTitle: 'Pomoć oko narudžbi',
    helperQuestion: 'Narudžbe se ne šalju?',
    helperSteps: 'Pratite korake u uputstvu za provjeru i ručnu sinhronizaciju narudžbi.',
    helperGuide: 'Otvori uputstvo',
    logoutError: 'Greška prilikom odjave.',
    openTasks: 'Otvoreni zadaci',
    pendingOrders: 'Narudžbe na čekanju',
    recentActivity: 'Nedavna aktivnost',
    retrying: 'Ponavljanje',
    routePlans: 'Hodogrami',
    startDay: 'Započni dan',
    startVisit: 'Započni posjetu',
    unknownCustomer: 'Nepoznat kupac',
  },
  customers: {
    title: 'Kupci',
    allCustomers: 'Svi kupci',
    cityFilter: 'Grad',
    allCities: 'Svi gradovi',
    withoutCity: 'Bez grada',
    noCustomersMatchingFilters: 'Nisu pronađeni kupci koji odgovaraju kriterijima pretrage',
    calculateOptimalRoute: 'Izračunaj optimalnu rutu',
    calculatingRoute: 'Računam rutu...',
    createNewCustomer: 'Kreiraj novog kupca',
    customerBlocked: 'Kupac je blokiran.',
    customerNotSelected: 'Kupac nije odabran.',
    dailyRoutesLoadError: 'Greška prilikom preuzimanja dnevnih ruta: {{message}}',
    debt: 'Dugovanje',
    deliveryPlaces: 'Mjesta isporuke',
    deliveryDay: 'Dan isporuke',
    endingPoint: 'Završna tačka',
    enterCustomer: 'Uđi u kupca',
    exitCustomer: 'Izađi iz kupca',
    forSearch: 'za',
    found: 'Pronađeno',
    loadingCustomers: 'Učitavam kupce...',
    mapLoadError: 'Greška pri učitavanju: {{message}}',
    nearbyCustomers: 'Kupci u blizini',
    noCustomers: 'Nema kupaca.',
    noCustomersInDailyRoute: 'Nema kupaca u današnjoj ruti',
    noCustomersWithValidLocations: 'Nema kupaca sa validnim lokacijama za odabrani datum',
    notes: 'Napomene',
    optimalRouteTitle: 'Optimalna ruta - redoslijed posjeta ({{count}} kupaca)',
    routeCustomers: 'Kupci na ruti',
    results: 'rezultata',
    pleaseSelectCustomer: 'Molimo odaberite kupca.',
    selectCustomerQuestion: 'Da li želite odabrati',
    startingPoint: 'Početna tačka',
    totalCustomers: 'Ukupno kupaca',
    visitOrder: 'Redoslijed posjete',
  },
  products: {
    priceInquiryLoading: 'Cijena se osvježava. Količinu možete unositi.',
    priceInquiryFailed: 'Cijena nije osvježena. Koristi se sačuvana cijena.',
    codeShort: 'Šifra',
    barcodeShort: 'Barkod',
    selectCustomerFirst: 'Molimo odaberite kupca prije odabira artikla.',
    selectCustomer: 'Molimo odaberite kupca.',
    upcomingPromotion: 'Nadolazeća: {{date}}',
    informativePriceNoStock: 'Informativna cijena za artikal bez dostupne količine.',
    title: 'Artikli',
    addToCart: 'Dodaj u korpu',
    assortment: 'Asortiman',
    availableStock: 'Dostupna zaliha',
    categoryFilter: 'Filter robne grupe',
    noProducts: 'Nema dostupnih artikala.',
    outOfStock: 'Nema na stanju',
    package: 'Pakiranje',
    price: 'Cijena',
    productHistory: 'Historija artikla',
    productNotFound: 'Artikal nije pronađen.',
    scanBarcode: 'Skeniraj barkod',
    posMaterials: 'POS Materijali',
    noProductsInDatabase: 'Nema dostupnih artikala u bazi podataka',
    noProductsInFilter: 'Nema artikala u {{filter}}',
    noProductsInTwoFilters: 'Nema artikala u {{first}} i {{second}}',
    noProductsMatchingFilters: 'Nema artikala koji odgovaraju svim primijenjenim filterima',
    fetchErrorWithMessage: 'Greška prilikom preuzimanja artikala: {{message}}',
    noPosProductsForChannel: 'Nema POS artikala za vaš kanal prodaje. Provjerite da li se vaš kanal poklapa sa kanalom dodijeljenim POS artiklima.',
    unavailableOffline: 'Nedostupno offline',
    noPackages: 'Nema pakiranja',
    packagesCount: '{{count}} pakiranja',
    packageShort: 'Pak',
    packageTypingActive: 'Paketno kucanje aktivno: {{count}} kom po paketu',
    customerHasNotOrderedProductSixMonths: 'Kupac nije naručivao artikal u proteklih 6 mjeseci.',
    productNotOrderedSixMonths: 'Artikal nije naručivan u proteklih 6 mjeseci.',
    lastOrdersDeliveriesLegend: 'Zadnje 4 narudžbe/isporuke',
    ordered: 'Naručeno',
    delivered: 'Isporučeno',
    salesHistoryLotTitle: 'Historija prodaje - lot (rok)',
    bestTerms: 'Najbolji uslovi',
    bestTermsForCustomer: 'po kupca za koje je artikal otišao su',
    byDiscount2: 'po rabatu2',
    priceOf: 'Cijena od',
    usedAsBasePrice: 'će se uzeti kao bazna cijena.',
    afterDiscountApplied: 'Nakon primjene sniženja {{discount}}%',
    highest: 'Najveći',
    discount2: 'rabat2',
    noDiscount2ForLot: 'Nema rabat2 za uneseni lot.',
    enterLot: 'Unesite lot.',
    stockByWarehouses: 'Zaliha po skladištima',
    branch: 'Poslovnica',
    centralWarehouse: 'Centralno skladište (Š. Brijeg)',
    showFullHistory: 'Prikaži punu historiju',
    historyWithCount: 'Historija - {{count}} stavki ({{months}} mj.)',
    orderedShort: 'Nar',
    deliveredShort: 'Isp',
    customerHasNotOrderedProduct: 'Kupac nije naručivao ovaj artikal.',
    noOrdersForProduct: 'Nema narudžbi za ovaj artikal.',
    showMoreMonths: 'Prikaži više (+{{months}} mj.)',
    promotionWithPercent: 'Akcija: {{percent}}%',
    rasterTooltip: 'Na rasteru {{operator}} ({{quantity}}){{required}}',
    listingRequiredTooltip: 'Potrebno je ulistati artikal{{required}}',
    filters: {
      selectedCategory: 'odabranoj kategoriji',
      selectedBrand: 'odabranom brendu',
      orderedProducts: 'naručivanim artiklima',
      withoutRecentSales: 'artiklima bez prodaje posljednjih 30 dana',
      discountedProducts: 'artiklima na akciji',
      listingProducts: 'ulistavanim artiklima',
      inStockProducts: 'artiklima na stanju',
      coloredProducts: 'obojenim artiklima',
      customerCategory: 'kategoriji kupca',
      selectedSupplier: 'odabranom dobavljaču',
    },
  },
  cart: {
    retailOutlet: 'Diskont',
    title: 'Korpa',
    addItems: 'Dodajte artikle u korpu.',
    cartEmpty: 'Korpa je prazna.',
    checkout: 'Zaključi narudžbu',
    clearCart: 'Očisti korpu',
    discount: 'Rabat',
    itemCount: 'Broj stavki',
    orderCreated: 'Narudžba je uspješno kreirana.',
    orderSaved: 'Narudžba je sačuvana.',
    paymentMethod: 'Način plaćanja',
    totalWithoutVat: 'Ukupno bez PDV-a',
    orderHeader: 'Zaglavlje',
    items: 'Stavke',
    dayHistory: 'Historija dana',
    discounts: 'Rabati',
    historyVpcNetto: 'Hist. VPC Netto',
    enterQuantity: 'Unesite količinu',
    totalWithVat: 'Ukupno sa PDV',
    totalVatRate: 'Ukupni PDV {{rate}}%',
    itemsWithQuantity: 'Stavki: {{count}} · Kom: {{quantity}}',
    sortInput: 'Unos',
    immediately: 'Odmah',
    daysCount: '{{count}} dana',
    searchCustomerByCodeOrNameMin2: 'Tražite kupca po šifri ili nazivu (min. 2 karaktera)',
    reference: 'Referenca',
    orderType: 'Tip narudžbe',
    notSelected: 'Nije odabrano',
    withVatPercent: 'Sa {{percent}}% PDV',
    paymentDeadline: 'Rok plaćanja',
    distance: 'Udaljenost',
    timeAtCustomer: 'Vrijeme kod kupca',
    weight: 'Težina',
    delivery: 'Isporuka',
    externalDocumentType: 'Vrsta vanposlovnog dokumenta',
  },
  orders: {
    title: 'Narudžbe',
    orderDetails: 'Detalji narudžbe',
    orderHistory: 'Historija narudžbi',
    orderNumber: 'Broj narudžbe',
    noOrders: 'Nema narudžbi.',
    noCompletedOrdersToday: 'Nema završenih narudžbi za današnji dan.',
    emptyCart: 'Ispraznite korpu',
    finishOrCancelStartedOrder: 'Potrebno je da završite ili poništite započetu narudžbu.',
    goTo: 'Idi na',
    repeatOrder: 'Ponovi narudžbu',
    sendOrder: 'Pošalji narudžbu',
    stopOrderAtCustomerQuestion: 'Da li želite da prekinete {{order}} kod',
    stopOrderAtCustomerAndStartQuestion: 'Da li želite prekinuti {{order}} kod {{customer}} i započeti {{order}} kod {{selectedCustomer}}?',
    cancelOrder: 'Storniraj narudžbu',
  },
  tasks: {
    title: 'Zadaci',
    assignedTo: 'Dodijeljeno',
    createTask: 'Kreiraj zadatak',
    dueDate: 'Rok',
    noTasks: 'Nema zadataka.',
    priority: 'Prioritet',
    taskDetails: 'Detalji zadatka',
    taskDocuments: 'Dokumenti zadatka',
    taskFinished: 'Zadatak je završen.',
    taskType: 'Tip zadatka',
    upcoming: 'Nadolazeći',
    expired: 'Istekli',
    allStatuses: 'Svi statusi',
    mine: 'Moji',
    new: 'Novi',
    unnamed: 'Bez naziva',
    completedOnTime: 'Završen u roku',
    completedCount: '{{count}}x završeno',
    listing: 'Ulistavanje',
    raster: 'Raster',
  },
  pendingOrders: {
    recentlyProcessed: 'Nedavno obrađene',
    allProcessed: 'Sve je obrađeno',
    noOrdersAwaitingApproval: 'Nema narudžbi koje čekaju odobrenje',
    fetchError: 'Greška prilikom preuzimanja KO narudžbi: {{message}}',
    waitingRouteSchedule: 'Narudžba br. {{number}} čeka vrijeme po hodogramu!',
    rejectOrderQuestion: 'Poništi KO narudžbu?',
    regularOrderQuestion: 'Želite li da narudžba bude prepisana kada joj je vrijeme po hodogramu?',
    regularOrder: 'Redovna narudžba',
  },
  reports: {
    title: 'Izvještaji',
    brandSales: 'Izvještaj po brendovima',
    customerDebt: 'Dugovanje kupca',
    dailyRealization: 'Dnevna realizacija',
    openItems: 'Otvorene stavke',
    realization: 'Realizacija',
    realizationPlan: 'Plan i realizacija',
    salesHistory: 'Historija prodaje',
    salesmanReport: 'Izvještaj komercijaliste',
    surveyHistory: 'Historija anketa',
    taskHistory: 'Historija zadataka',
    visitHistory: 'Historija posjeta',
  },
  surveys: {
    title: 'Ankete',
    answerRequired: 'Odgovor je obavezan.',
    noSurveys: 'Nema dostupnih anketa.',
    surveyCompleted: 'Anketa je završena.',
    yesMeansPresent: 'Da znači da je artikal prisutan kod kupca, ne da nije.',
  },
  ocr: {
    title: 'Skeniranje',
    addScannedProduct: 'Dodaj skenirani artikal',
    barcodeCopied: 'Barkod je kopiran.',
    scanDocument: 'Skeniraj dokument',
    scanFailed: 'Greška pri skeniranju dokumenta.',
    scannedProducts: 'Skenirani artikli',
  },
  admin: {
    title: 'Administracija',
    addUser: 'Dodaj korisnika',
    deleteUser: 'Obriši korisnika',
    organization: 'Organizacija',
    permissions: 'Dozvole',
    subordinateAgents: 'Podređeni putnici',
    userCreated: 'Korisnik je kreiran.',
  },
  gps: {
    title: 'GPS',
    locationUnavailable: 'Lokacija nije dostupna.',
    weakSignal: 'GPS signal je slab ili nedostupan.',
  },
  pwa: {
    install: 'Instaliraj aplikaciju',
    updateAvailable: 'Dostupna je nova verzija aplikacije.',
    updateNow: 'Ažuriraj sada',
  },
  language: {
    title: 'Jezik',
    changedTo: 'Jezik je promijenjen na',
    changeFailed: 'Nije moguće učitati odabrani jezik.',
  },
  placeholders: {
    search: 'Pretraga...',
    searchMin2: 'Pretraga (min. 2 slova)',
    searchCustomersMin2: 'Traži kupce (min. 2 slova)',
    searchTaskOrId: 'Traži po zadatku ili ID-u...',
    searchTaskOrCustomer: 'Traži po zadatku ili kupcu...',
    searchCodeOrName: 'Pretraži po šifri ili nazivu...',
    searchGroup: 'Pretraži grupu...',
    searchBrand: 'Pretraži brend...',
    selectTaskStatus: 'Odaberi status zadatka',
    selectOrganization: 'Odaberi organizaciju...',
    selectSalesmen: 'Odaberi putnike...',
    selectSupervisor: 'Odaberi nadređenog...',
    selectSubordinateSalesmen: 'Odaberi podređene putnike...',
    selectTaskPriority: 'Odaberi prioritet zadatka...',
    selectTaskType: 'Odaberi tip zadatka...',
    selectCustomers: 'Odaberi kupce...',
    selectExecutor: 'Odaberi izvršioca...',
    selectBrand: 'Odaberi brend...',
    selectProducts: 'Odaberi artikle...',
    enterBarcodeOrProductName: 'Unesite barkod ili naziv artikla',
    enterReason: 'Unesite obrazloženje',
    enterComment: 'Unesite komentar...',
    enterNumber: 'Unesite broj',
    listName: 'Naziv liste',
    customerName: 'Naziv prodajnog mjesta *',
    centralOffice: 'Centrala *',
    organizationType: 'Oblik organiziranja *',
    enterOrganizationType: 'Unesite oblik organiziranja *',
    specialCategory: 'Specijalna kategorija *',
    address: 'Adresa *',
    city: 'Mjesto *',
    latitude: 'Latitude',
    longitude: 'Longitude',
    taxId: 'JIB *',
    vatId: 'PDV / ID broj',
    branch: 'Podružnica *',
    visitDay: 'Dan obilaska *',
    salesman: 'Komercijalist',
    phone: 'Telefon',
    email: 'Email',
    contactPerson: 'Kontakt osoba',
    note: 'Napomena',
    koPercent: 'KO%',
    quantity: 'Količina',
    expiryDate: 'Rok',
    lot: 'Lot',
    dateFrom: 'Datum od',
    dateTo: 'Datum do',
  },
  columns: {
    customer: 'Kupac',
    customerCode: 'Šifra kupca',
    customerName: 'Naziv kupca',
    product: 'Artikal',
    productCode: 'Šifra artikla',
    productName: 'Naziv artikla',
    orderNumber: 'Broj narudžbe',
    orderDate: 'Datum narudžbe',
    deliveryDate: 'Datum dostave',
    dueDate: 'Datum dospijeća',
    status: 'Status',
    quantity: 'Količina',
    orderedQuantity: 'Naručena količina',
    soldQuantity: 'Prodata količina',
    price: 'Cijena',
    discount: 'Rabat',
    total: 'Ukupno',
    debt: 'Dugovanje',
    dueDebt: 'Dospjelo dugovanje',
    invoice: 'Faktura',
    invoiceDate: 'Datum fakture',
    currency: 'Valuta',
    route: 'Ruta',
    agent: 'Putnik',
    task: 'Zadatak',
    taskType: 'Tip zadatka',
    priority: 'Prioritet',
    startDate: 'Datum početka',
    endDate: 'Datum završetka',
    createdBy: 'Kreirao',
    createdAt: 'Datum kreiranja',
    actions: 'Akcije',
    comment: 'Komentar',
    barcode: 'Barkod',
    brand: 'Brend',
    category: 'Robna grupa',
    location: 'Lokacija',
    paymentMethod: 'Način plaćanja',
    document: 'Dokument',
    fileName: 'Naziv fajla',
  },
  filters: {
    quickFilter: 'Brzi filter',
    compact: 'Kompakt',
    minimal: 'Min',
    sortByName: 'Sortiraj po nazivu',
    sortByCode: 'Sortiraj po šifri',
    last30Days: 'Zadnjih 30 dana',
    withoutRecentSales: 'Bez nedavne prodaje',
    productGroup: 'Robna grupa',
    supplier: 'Dobavljač',
    brand: 'Brend',
    status: 'Status',
    dateRange: 'Period',
  },
  modals: {
    leaveCustomerTitle: 'Napustiti objekat?',
    leaveCustomerConfirm: 'Da, izađi',
    leaveCustomerCancel: 'Ostani u objektu',
    clearProductsTitle: 'Potvrda čišćenja artikala',
    clearAllProductsTitle: 'Potvrda čišćenja svih artikala',
    selectAllProductsTitle: 'Potvrda odabira svih artikala',
    deleteListTitle: 'Obrisati listu?',
    selectProductGroupTitle: 'Odaberite robnu grupu',
    cannotLogoutDayStarted: 'Nije moguće odjaviti se dok je dan započet.',
    ordersToSend: 'Narudžbe za slanje',
    visitsToday: 'Posjete danas',
    finishTaskTitle: 'Završiti zadatak?',
    saveAsList: 'Sačuvaj kao listu',
    deleteLocalOrdersTitle: 'Obrisati lokalne narudžbe?',
    removeProductTitle: 'Ukloniti artikal?',
  },
  messages: {
    productAdded: 'Artikal je dodan.',
    productNotFound: 'Artikal nije pronađen.',
    barcodeCopied: 'Barkod je kopiran.',
    barcodeCopyError: 'Barkod nije moguće kopirati.',
    orderApproved: 'Narudžba je odobrena.',
    orderRejected: 'Narudžba je odbijena.',
    unknownStatus: 'Nepoznat status.',
    newCustomerCreated: 'Novi kupac je kreiran.',
    newCustomerQueued: 'Novi kupac je spremljen za slanje.',
    newCustomerQueueError: 'Nije moguće spremiti novog kupca za slanje.',
    dayAlreadyFinished: 'Dan je već završen.',
    dataUpdated: 'Podaci uspješno ažurirani.',
    eventInsertError: 'Greška prilikom upisa eventa:',
    invalidPassword: 'Lozinka nije ispravna.',
    lotRequired: 'Lot je obavezan.',
    selectCustomerFirst: 'Prvo odaberite kupca.',
    taskInvalid: 'Zadatak nije ispravan.',
    commentRequired: 'Komentar je obavezan.',
    photoRequired: 'Fotografija je obavezna.',
    numberRequired: 'Broj je obavezan.',
    locationRequiredToFinishTask: 'Lokacija je obavezna za završetak zadatka.',
    taskCompleted: 'Zadatak je završen.',
    localChangeSaveError: 'Lokalnu izmjenu nije moguće sačuvati.',
    imageProcessingError: 'Greška prilikom obrade slike.',
    statusUpdated: 'Status je ažuriran.',
    templateNameRequired: 'Naziv šablona je obavezan.',
    templateNameTooShort: 'Naziv šablona je prekratak.',
    templateSaved: 'Šablon je sačuvan.',
    templateSaveError: 'Šablon nije moguće sačuvati.',
    templateDeleted: 'Šablon je obrisan.',
    templateDeleteError: 'Šablon nije moguće obrisati.',
    documentAttached: 'Dokument je priložen.',
    documentUploadError: 'Dokument nije moguće poslati.',
    autoImageUpdate: 'Slika je automatski ažurirana.',
    autoImageUpdateError: 'Sliku nije moguće automatski ažurirati.',
    orderRepeated: 'Narudžba je ponovljena.',
    orderRepeatError: 'Narudžbu nije moguće ponoviti.',
    updateFailedWithMessage: 'Neuspješan pokušaj ažuriranja: {{message}}',
    areYouSure: 'Da li ste sigurni?',
  },
  emptyStates: {
    noAssignmentsForTask: 'Nema dodjela za ovaj zadatak.',
    noDocuments: 'Nema dokumenata.',
    noSavedLists: 'Nema sačuvanih lista.',
    noSavedOrders: 'Nema sačuvanih narudžbi.',
    noOpenItems: 'Nema otvorenih stavki.',
    noOpenItemsForCustomer: 'Nema otvorenih stavki za ovog kupca.',
    noCompletedTasks: 'Nema završenih zadataka.',
    noSurveyHistory: 'Nema historije anketa.',
    noDailyGroupRealization: 'Nema dnevne realizacije po grupama.',
    noPlansForMonth: 'Nema planova za odabrani mjesec.',
    noResultsForMonth: 'Nema rezultata za odabrani mjesec.',
    noCustomersForSelectedAgents: 'Nema kupaca za odabrane putnike.',
    noSalesmenForSelectedObjects: 'Nema komercijalista za odabrane objekte.',
    noProductsForRaster: 'Nema artikala za raster.',
    noProductsForListing: 'Nema artikala za listing.',
    cartEmpty: 'Korpa je prazna.',
  },
  tooltips: {
    copyBarcode: 'Kopiraj barkod',
    openGoogleMaps: 'Otvori Google Maps',
    promotion: 'Akcija',
    upcomingPromotion: 'Nadolazeća akcija',
    onRaster: 'Na rasteru',
    listingRequired: 'Obavezan listing',
    details: 'Prikaži detalje',
  },
  network: {
    good: 'Dobra konekcija',
    moderate: 'Osrednja konekcija',
    fair: 'Slaba konekcija',
    poor: 'Jako slaba konekcija',
    dataSaver: 'Štednja podataka',
  },
  taskExecution: {
    infoMessage: 'Info poruka',
    repeatedInfoMessage: 'Info poruka (višekratni)',
    mandatoryComment: 'Obavezan komentar',
    mandatoryPhoto: 'Obavezna fotografija',
    mandatoryPhotoAndComment: 'Obavezna fotografija i komentar',
    positionCheck: 'Provjera pozicija',
    waitingAssignment: 'Čeka dodjelu',
    waitingRegular: 'Čeka redovnu',
  },
  newCustomer: {
    title: 'Novi kupac',
    salesLocationName: 'Naziv prodajnog mjesta',
    centralOffice: 'Centrala',
    organizationType: 'Oblik organiziranja',
    specialCategory: 'Specijalna kategorija',
    address: 'Adresa',
    city: 'Mjesto',
    latitude: 'Latitude',
    longitude: 'Longitude',
    taxId: 'JIB',
    vatId: 'PDV / ID broj',
    branch: 'Podružnica',
    visitDay: 'Dan obilaska',
    salesman: 'Komercijalist',
    phone: 'Telefon',
    email: 'Email',
    contactPerson: 'Kontakt osoba',
    note: 'Napomena',
    contact: 'Kontakt',
    enterOrganizationType: 'Unesite oblik organiziranja',
    identification: 'Identifikacija',
    paymentAndDelivery: 'Plaćanje i dostava',
    routeAndSalesman: 'Ruta i komercijalist',
    salesLocation: 'Prodajno mjesto',
  },
  units: {
    items: 'stavki',
    pieces: 'kom',
    days: 'dana',
    monthShort: 'mj.',
    yearShort: 'god.',
    kilometers: 'km',
    percent: '%',
    currency: 'KM',
  },
  account: {
    title: 'Nalog',
    emailAddress: 'E-mail adresa',
    location: 'Lokacija',
    organization: 'Organizacija',
    salesChannel: 'Kanal prodaje',
    role: 'Uloga',
    adminAuthorization: 'Admin autorizacija',
    password: 'Lozinka',
  },
  issueReport: {
    title: 'Prijavite problem',
    yourName: 'Vaše ime',
    emailAddress: 'Email adresa',
    problemDescription: 'Opis problema',
    yourEmailPlaceholder: 'vaš@email.com',
    namePlaceholder: 'Unesite vaše ime',
    descriptionPlaceholder: 'Detaljno opišite problem koji ste doživjeli...',
    sent: 'Hvala! Vaša prijava je poslana.',
    sendError: 'Greška prilikom slanja prijave.',
  },
  customerNotes: {
    title: 'Napomene kupca',
    newNotePlaceholder: 'Nova napomena...',
    editNote: 'Uredi napomenu',
    deleteNoteTitle: 'Obrisati napomenu?',
    loadError: 'Greška pri učitavanju napomena',
    emptyNote: 'Unesite tekst napomene',
    noteAdded: 'Napomena je dodana',
    noteAddError: 'Greška pri dodavanju napomene',
    noteUpdated: 'Napomena je ažurirana',
    noteUpdateError: 'Greška pri ažuriranju napomene',
    noteDeleted: 'Napomena je obrisana',
    noteDeleteError: 'Greška pri brisanju napomene',
    addNote: 'Dodaj napomenu',
    dateAt: '{{date}} u {{time}}',
    dayAt: '{{day}} u {{time}}',
    localOnlyNotice: 'Napomene se čuvaju lokalno na vašem uređaju',
    todayAt: 'Danas u {{time}}',
    yesterdayAt: 'Jučer u {{time}}',
  },
  createTask: {
    title: 'Kreiraj zadatak',
    subtitle: 'Unesite osnovne informacije o zadatku',
    taskName: 'Naziv zadatka',
    taskNamePlaceholder: 'Unesite naziv zadatka',
    messageNote: 'Poruka / Napomena',
    messageNotePlaceholder: 'Unesite dodatnu poruku ili napomenu',
    taskTypeForAllProducts: 'Tip zadatka (za sve artikle)',
    optionalTaskTypePlaceholder: 'Odaberi tip zadatka (opcionalno)',
    noteForAllProducts: 'Napomena (za sve artikle)',
    noteForAllProductsPlaceholder: 'Napomena koja će se primijeniti na sve artikle',
    individualProductNotePlaceholder: 'Individualna napomena za ovaj artikal',
    searchCustomersObjects: 'Pretraži kupce/objekte...',
    searchProductAssortment: 'Pretraži po šifri, nazivu ili asortimanu...',
    subjects: 'Subjekti',
    deliveryPlaces: 'Dostavna mjesta',
    products: 'Artikli',
    salesmen: 'Putnici',
    details: 'Detalji',
    createAnotherTaskTitle: 'Zadati još jedan zadatak?',
    taskCreated: 'Uspješno kreiran zadatak',
    batchTasksCreated: 'Uspješno kreirano {{count}} zadataka',
    batchTasksCreateError: 'Kreiranje zadataka nije uspjelo: {{message}}',
    selectAtLeastOneCustomer: 'Odaberite barem jedan objekat/kupca',
    selectAtLeastOneDeliveryPlace: 'Odaberite barem jedno dostavno mjesto',
    selectAtLeastOneProduct: 'Odaberite barem jedan artikal',
    selectAtLeastOneSalesman: 'Odaberite barem jednog putnika',
    taskNameRequired: 'Naziv zadatka je obavezan',
    datesRequired: 'Datumi su obavezni',
    invalidDateRange: 'Datum početka ne može biti nakon datuma završetka',
    noSalesmenForCustomer: 'Nema putnika za odabrani objekat',
    salesmenLoadError: 'Greška pri dohvaćanju putnika',
    createTaskError: 'Greška pri kreiranju zadatka: {{message}}',
  },
  orderHistory: {
    history: 'Historija',
    userAction: 'Akcija korisnika',
    waitingSupervisor: 'Čeka nadređenog',
    waitingProcessing: 'Čeka obradu',
    inProgress: 'U izradi',
    finished: 'Završena',
    canceled: 'Stornirana',
    deleted: 'Obrisana',
    abandoned: 'Odustano',
    approved: 'Odobrena',
    annulled: 'Poništena',
    invoiced: 'Fakturisana',
    received: 'Primljena',
    sent: 'Poslana',
    atSupervisor: 'Kod nadređenog',
    restoreTitle: 'Vratiti narudžbu?',
    sendTitle: 'Poslati narudžbu?',
    deleteTitle: 'Obrisati narudžbu?',
    restoreConfirm: 'Da, vrati',
    sendConfirm: 'Da, pošalji',
  },
  reportColumns: {
    planned: 'Planirano',
    realized: 'Ostvareno',
    realizationPercent: 'Postotak realizacije',
    productGroup: 'Robna grupa',
    brand: 'Brend',
    totalDebt: 'Ukupno dugovanje',
    due0To7: 'Dana 1-7',
    due8To15: 'Dana 8-15',
    due16To30: 'Dana 16-30',
    due31To60: 'Dana 31-60',
    due61To90: 'Dana 61-90',
    due90Plus: 'Dana 90+',
    due1To15: 'Dana 1-15',
    due61Plus: 'Dana 61+',
    lastOrderDate: 'Datum zadnje narudžbe',
    lastVisitDate: 'Datum zadnje posjete',
    visitsCount: 'Broj posjeta',
    ordersCount: 'Broj narudžbi',
  },
  debug: {
    title: 'Debug Panel',
    timeMs: 'Vrijeme (ms)',
    longTasks: 'Dugi zadaci',
    connection: 'Konekcija',
    appNetworkState: 'Mrežno stanje aplikacije',
    localStorage: 'LocalStorage',
    indexedDb: 'IndexedDB',
    application: 'Aplikacija',
    session: 'Sesija',
    hardware: 'Hardver',
    screen: 'Ekran',
    possibleCauses: 'Mogući uzroci',
    recommendations: 'Preporuke',
    quickStats: 'Brze statistike',
    clearAllLogs: 'Obriši sve logove',
  },
  auth: {
    email: 'E-mail',
    password: 'Password',
    signIn: 'Prijava',
    signOut: 'Odjava',
    forgotPassword: 'Zaboravljena lozinka',
    invalidCredentials: 'Neispravni pristupni podaci.',
  },
  checkout: {
    queueError: 'Narudžba nije dodana u red za slanje',
    queueErrorItemsKept: 'Stavke su ostale u korpi. Nakon otklanjanja greške ponovo zaključite narudžbu.',
    statusNetworkCheck: 'Provjera stabilnosti mreže...',
    statusProcessingImages: 'Obrađivanje KO slika ({{processed}}/{{total}})...',
    statusCreatingOrder: 'Kreiranje narudžbe...',
    orderSaveTakingLong: 'Čuvanje narudžbe traje duže od očekivanog. Sačekajte završetak; korpa će ostati sačuvana ako upis ne uspije.',
    paymentMethodPrompt: 'Izaberite način plaćanja',
    orderBlockedCustomer: 'Narudžbu nije moguće zaključiti za blokiranog kupca.',
    orderSaved: 'Narudžba je sačuvana!',
    orderSuccessful: 'Narudžba uspješna!',
    orderWriteError: 'Greška kod upisa narudžbe u sistem!',
    selectDate: 'Unesite datum',
    customerRequiredBeforeProduct: 'Molimo odaberite kupca prije odabira artikla.',
    customerRequired: 'Molimo odaberite kupca.',
    changeQuantity: 'Izmijeni količinu',
    itemCommentPlaceholder: 'Komentar za stavku...',
    productCommentPlaceholder: 'Komentar uz artikal (opcionalno)',
    groupSummary: 'Pregled po robnim grupama',
    freeCart: 'Korpa je prazna',
    packageTyping: 'Paketno kucanje',
    orderTypePlaceholder: 'Odaberi vrstu naloga',
    orderSentForApproval: 'Narudžba je poslana na odobrenje!',
    orderWaitingApproval: 'Narudžba čeka odobrenje i neće biti obrađena kao regularna narudžba.',
    createNewDocumentQuestion: 'Da li želite da kreirate novi dokument?',
    orderQueuedForManualSync: 'Narudžba je dodana u red i biće poslana prilikom ručne sinhronizacije.',
    orderWillSendWhenOnline: 'Narudžba će biti automatski poslana kada se povežete na internet.',
    tobaccoOppositeGroupError: 'Narudžba je {{group}}. Dodali ste i artikle iz {{oppositeGroup}} robne grupe, molimo izbacite {{oppositeGroup}} artikle iz narudžbe.',
    tobaccoMixedGroupsError: 'Dodali ste artikle i iz BAT i iz TOBAČNA robne grupe, molimo da izbacite jednu grupu iz narudžbe.',
    customerHasNoLocation: 'Kupac nema lokaciju',
    gpsSignalWeak: 'GPS signal slab',
    documentRequired: 'Morate odabrati dokument!',
    organizationRequired: 'Morate odabrati organizaciju!',
    duplicateCartItems: 'Duplirane stavke u korpi: {{items}}. Uklonite duplikate prije zaključivanja.',
    deliveryPlaceRequired: 'Mjesto isporuke je obavezno',
    missingQuantities: 'Nedostaju količine',
    customerBlocked: 'Kupac je blokiran',
    customerBlockedSyncBeforeSending: 'Kupac je blokiran. Odradite sinhronizaciju prije slanja narudžbe.',
    customerUnblockedSyncBeforeSending: 'Kupac je odblokiran. Odradite sinhronizaciju, pa narudžbu pošaljite regularno.',
    orderWillBeSentForApproval: 'Narudžba će biti poslana na odobrenje.',
    gpsLocationUnavailable: 'GPS lokacija nije dostupna',
    gpsTimeoutDescription: 'GPS signal je predugo nedostupan. Narudžba će biti kreirana bez tačne lokacije. Provjerite da li ste omogućili pristup lokaciji i pokušajte ponovo.',
    gpsWeakDescription: 'GPS signal je slab ili nedostupan. Narudžba će biti kreirana bez tačne lokacije. Pokušajte izaći napolje za bolji signal.',
    blocked: 'Blokiran',
    submitting: 'Slanje...',
    processing: 'Obrađuje se...',
    sendForApproval: 'Pošalji na odobrenje',
    submitOrderOffline: 'Zaključi narudžbu (Offline)',
    submitSlowConnection: 'Zaključi (Spora veza)',
    saveForLater: 'Sačuvaj za kasnije',
    clearCartConfirm: 'Da li ste sigurni? Sve stavke će biti izbrisane.',
    photosRequired: 'Fotografije su obavezne!',
    listingOrRasterQuantitiesRequired: 'Potrebno je dodati artikle za ulistavanje ili uskladiti količine raster artikala!',
  },
  offlineSync: {
    manualModeTitle: 'Ručni režim - Automatska sinhronizacija isključena',
    manualModeDescription: 'Operacije će biti sačuvane, ali neće biti automatski sinhronizirane. Koristite dugme ispod za ručnu sinhronizaciju.',
    manualModeHint: 'Kada je isključeno, morat ćete ručno potvrditi sinhronizaciju',
    autoSyncBlockedPending: 'Automatsku sinhronizaciju nije moguće uključiti dok u redu za slanje ima operacija. Prvo sinhronizujte sve operacije.',
    persistentStorageDeniedTitle: 'Trajno čuvanje podataka nije odobreno',
    persistentStorageDeniedDescription: 'Pretraživač može obrisati lokalne podatke aplikacije kada na uređaju ponestane prostora. Oslobodite prostor na uređaju da narudžbe na čekanju ne bi bile izgubljene.',
    pendingOperationsDescription: 'Ove operacije nisu poslane na server. Možete ih pokušati ponovo ili obrisati.',
    syncConfirmationTitle: 'Potvrda sinhronizacije',
    removeRequestTitle: 'Da li ste sigurni da želite ukloniti ovaj zahtjev?',
    removeConfirm: 'Da, ukloni',
    serverValidationInfo: 'Narudžbe će biti provjerene na serveru, pa dodane u red ako nisu već poslane.',
    clearLocalOrders: 'Očisti lokalne narudžbe',
    clearLocalOrdersConfirm: 'Jeste li sigurni da želite obrisati sve lokalne narudžbe?',
  },
  location: {
    gpsDisabledTitle: 'GPS Lokacija Onemogućena',
    setNewLocationConfirm: 'Da li ste sigurni da želite postaviti novu lokaciju?',
    openGoogleMaps: 'Otvori u Google Maps',
    atCustomerLocationQuestion: 'Nalazite li se na lokaciji kupca?',
    atLocationQuestion: 'Nalazite li se na lokaciji?',
    customerNoLocationPrompt: 'Ovom korisniku nije dodijeljena lokacija. Želite li postaviti svoju trenutnu lokaciju kao njegovu lokaciju?',
    distanceFromCustomer: 'Udaljeni ste {{distance}} od kupca.',
    distanceFromCustomerMeters: 'Udaljeni ste {{distance}} m od kupca.',
    enableLocation: 'Uključite lokaciju.',
    setCurrentLocationAsCustomer: 'Želite li postaviti trenutnu lokaciju kao lokaciju kupca?',
    setLocationAction: 'Postavi',
    setLocationConfirm: 'Da li ste sigurni da želite postaviti lokaciju?',
    yesUpper: 'DA',
    noUpper: 'NE',
    greenMarker: 'green circle',
    blueMarker: 'blue circle',
  },
  batSurvey: {
    title: 'BAT anketa',
    help: 'Pomoć',
    howToUse: 'Kako koristiti aplikaciju',
    customerSearchPlaceholder: 'Naziv, šifra, grad ili adresa',
    noEntries: 'Nema BAT unosa za prikaz',
    readonlyTitle: 'Pregled BAT unosa',
    noResults: 'Nema rezultata pretrage',
    surveyCompleted: 'Anketa uspješno ispunjena!',
    selectAtLeastOneProduct: 'Označite bar jedan artikal prije zaključivanja.',
    taskNotFoundOnDevice: 'Zadatak nije pronađen na uređaju.',
    chooseDate: 'Odaberi datum',
  },
  customerInfo: {
    title: 'Informacije o kupcu',
    info: 'Info',
    name: 'Ime',
    city: 'Grad',
    address: 'Adresa',
    phone: 'Telefon',
    phoneShort: 'Tel',
    category: 'Kategorija',
    parentObject: 'Nadređeni objekt',
    customerLocation: 'Lokacija kupca',
    dailyOrders: 'Dnevne narudžbe',
    dailyVisits: 'Dnevne posjete',
    dueDebt: 'Dospjeli dug',
    openTasks: 'Otvoreni zadaci:',
    mandatoryTasks: 'Obavezni zadaci:',
    predefinedComments: 'Predefinisani komentari',
    description: 'Opis',
    visitComment: 'Komentar',
  },
  customerDebt: {
    allBranches: 'Sve podružnice',
    branches: 'Podružnice',
    branchesCount: '{{count}} podružnica',
    currentCustomer: 'Trenutni kupac',
    days0To30: '0-30 dana',
    daysCount: '{{count}} dana',
    documentDate: 'Datum dok.',
    documentShort: 'Dok',
    dueDate: 'Dospjeće',
    dueDebt: 'Dospjeli dug',
    dueShort: 'Dosp.',
    errorWithMessage: 'Greška: {{message}}',
    inCurrency: 'u valuti',
    itemsCount: '{{count}} stavki',
    lastSync: 'Zadnja sinhronizacija',
    late: 'Kasni',
    lateCount: '{{count}} kasni',
    next7Days: 'za 7 dana',
    noOpenItemsForCurrentYear: 'Nema otvorenih stavki za ovog kupca u ovoj godini.',
    notDue: 'Nedospjelo',
    notDueDebt: 'Dug u valuti',
    onTime: 'u roku',
    openItems: 'Otvorene stavke',
    openItemsPermissionHint: 'Ako očekujete podatke, provjerite da li vaš kanal prodaje ima uključen pregled potraživanja.',
    outOfCurrency: 'Van valute',
    overdueCount: '{{count}} dospjelo',
    overdueDebt: 'Dug van valute',
    prepayments: 'Pretplate / KO',
    receivableDue: 'Potraživanje (dospjelo)',
    receivables: 'Potraživanja',
    showAllOpenItems: 'Prikaži sve otvorene stavke',
    showOpenItems: 'Prikaži otvorene stavke',
    thisWeekDebt: 'Dug ove sedmice',
    totalAmount: 'Ukupan iznos',
    totalBalance: 'Ukupno saldo',
    totalDebt: 'Ukupan dug',
  },
  visit: {
    createErrorWithMessage: 'Greška prilikom kreiranja posjete! {{message}}',
    queueErrorWithMessage: 'Greška pri dodavanju posjete u red: {{message}}',
    recordCreatedWithId: 'Kreiran je zapis o posjeti id: {{id}}!',
    recordQueued: 'Zapis o posjeti je dodan u red za slanje.',
    recordVisitQuestion: 'Da li želite zabilježiti posjetu kod kupca:',
    selectPredefinedComment: 'Izaberite predefinisani komentar.',
  },
  customerAction: {
    activeOrderTypeAfter: ', ako želite da izmijenite, prvo ispraznite korpu.',
    activeOrderTypeBefore: 'Trenutno je aktivna',
    autoAddRasterError: 'Nije moguće automatski dodati raster artikle. Molimo dodajte ih ručno.',
    batSurveys: 'BAT Ankete',
    batSurveysOptional: 'BAT Ankete (opcionalno)',
    createTaskForObject: 'Kreiraj zadatak za ovaj objekat',
    completedTaskRecheck: 'Zadatak je već završen. Izađite i uđite ponovo za ponovnu provjeru.',
    distribution: 'Distribucija',
    distributionQueued: 'Distribucija spremljena lokalno. Čeka sinhronizaciju.',
    distributionSaved: 'Distribucija uspješno spremljena!',
    distributionWithCount: 'Distribucija ({{count}})',
    finishBeforeLeaving: 'Potrebno je završiti {{items}} prije nego što napustite kupca!',
    finishOrderOrEmptyCartBeforeLeaving: 'Potrebno je dovršiti narudžbu ili isprazniti korpu prije nego što napustite kupca!',
    exitSaveError: 'Izlazak iz objekta nije sačuvan. Pokušajte ponovo.',
    incompleteWorkWarning: 'Postoje nedovršeni zadaci ili ankete',
    leave: 'Napusti',
    leaveCustomerQuestion: 'Napustiti kupca?',
    leaveObject: 'Napusti objekat',
    listingProductsRequired: 'Potrebno izvršiti ulistavanje sljedećih artikala:',
    noMandatoryTasksForCustomer: 'Nema obaveznih zadataka za ovog kupca.',
    noOpenTasksForCustomer: 'Nema otvorenih zadataka za ovog kupca.',
    noProductsToCheck: 'Nema artikala za provjeru.',
    openTasks: 'otvorene zadatke',
    optionalInVisit: 'Opcionalno u posjeti',
    pendingOrders: 'Narudžbe na čekanju: {{count}}',
    pendingPart: 'od toga {{count}} čeka',
    pendingSyncShort: 'Čeka sync',
    pendingSyncMessage: 'Podaci za ovog kupca čekaju sinhronizaciju. NISU izgubljeni.',
    pendingVisits: 'Posjete na čekanju: {{count}}',
    productsCount: '{{count}} artikala',
    rasterProducts: 'Raster artikli:',
    rasterSkippedByTargetGroup: 'Raster artikli izvan odabrane grupe nisu dodani u korpu ({{count}}).',
    requiredAndOpenTasks: 'obavezne i otvorene zadatke',
    requiredTasks: 'obavezne zadatke',
    reviewTab: 'molimo pregledajte tab',
    routeVisit: 'Hodogramska posjeta',
    routeVisitTasksOptional: 'Hodogramska posjeta — artikalski zadaci i ankete su opcionalni',
    start: 'Započni',
    startAndAdd: 'Započni i dodaj ({{count}})',
    stay: 'Ostani',
    selectTask: 'Odaberite zadatak',
    surveysCount: '{{count}} anketu/a',
    surveysOptional: 'Ankete (opcionalno)',
    tasksCount: '{{count}} zadatak(a)',
    title: 'Akcije',
    todayVisitsReadError: 'Greška pri čitanju današnjih posjeta:',
    visitOnlyOptionalMessage: 'Narudžba, artikalski zadaci i ankete nisu obavezni u ovoj posjeti.',
    youHave: 'Imate',
  },
  productDetails: {
    vpcMpc: 'VPC / MPC',
    packages: 'Pakiranja',
    noHistory: 'Nema Historije',
    invalidBarcodes: 'Neispravni Barkodi',
    notFound: 'Nije Pronađeno',
    clickToCopyBarcode: 'Kliknite da kopirate barkod',
    removeProductConfirm: 'Jeste li sigurni da želite ukloniti ovaj artikal?',
    actions: 'Akcije',
    previousCustomerProducts: 'Artikli koje je kupac ranije uzimao, ali ne u posljednjih 30 dana',
    brandsUpper: 'BRENDOVI',
    searchSuppliers: 'Pretraži dobavljače...',
  },
  taskManage: {
    addCommentPlaceholder: 'Dodaj komentar...',
    noAssignments: 'Nema dodjela za ovaj zadatak',
    noFoundObjects: 'Nema pronađenih objekata',
    noSelectedAgents: 'Niste odabrali agente',
    taskDescription: 'Opis zadatka',
    selectTaskType: 'Odaberi tip zadatka',
    additionalDescription: 'Dodatni opis ili poruka',
    messageDescriptionOptional: 'Poruka/Opis (opcionalno)',
    noSubordinateAgents: 'Nemate podređenih agenata',
    contactAdminForBrands: 'Kontaktirajte administratora da vam dodijeli brendove.',
    contactAdminForDeliveryPlaces: 'Kontaktirajte administratora da vam dodijeli dostavna mjesta.',
    requiresInternet: 'Kreiranje zadatka zahtijeva aktivnu internet konekciju.',
    requiresInternetLong: 'Kreiranje zadatka zahtijeva aktivnu internet konekciju. Molimo provjerite vašu mrežu prije nego što nastavite.',
    searchAgents: 'Pretraži agente...',
    searchCustomers: 'Pretraži kupce...',
    searchDeliveryPlaces: 'Pretraži dostavna mjesta...',
  },
  remainingUi: {
    cancelAlternative: 'Odustani',
    deliveryPlaceRequiredBeforeCheckout: 'Za ovog kupca morate odabrati mjesto isporuke prije zaključivanja narudžbe.',
    allProductsNeedQuantity: 'Svi artikli moraju imati unesenu količinu prije zaključivanja narudžbe.',
    quantityShort: 'kol.',
    searchDeliveryPlace: 'Traži mjesto isporuke',
    removePhoto: 'Ukloni fotografiju',
    finalize: 'Zaključi',
    surveyAnswerMeaning: 'Y znači da je artikal prisutan kod kupca, N da nije. Komentar i fotografija uz artikal su opcionalni.',
    draft: 'Draft',
    noNotes: 'Nema napomena',
    networkAndSyncStatus: 'Status mreže i sinhronizacija',
    syncRequiresOnline: 'Za sinhronizaciju je potrebna internet veza. Prebacite se u ONLINE režim.',
    refreshPendingActions: 'Ručno osvježi akcije na čekanju',
    notFound404: '404',
    customerDistance: 'Udaljenost od klijenta',
    retention: 'Zadržavanje',
    noSavedListsExact: 'Nema sačuvanih lista',
    remote: 'Udaljeno',
    selectSubordinateSalesmenDoubleDot: 'Odaberi podređene putnike..',
    userDeleted: 'Korisnik izbrisan!',
    adminShort: 'Admin',
    changeCustomer: 'Promijeni kupca',
    noSalesmenForSelectedObjectsExact: 'Nema putnika za odabrane objekte',
    noSalesmenForSelectedDeliveryPlaces: 'Nema putnika za odabrana dostavna mjesta',
    noCustomersForSelectedAgentsExact: 'Nema kupaca za odabrane agente',
    selectProductGroup: 'Odaberi robnu grupu',
    enterTaskDescription: 'Unesite opis zadatka',
    searchByCodeOrNameCustomer: 'Traži po šifri ili nazivu...',
    visits: 'Posjete',
    specialCategoryShort: 'Spec. kategorija',
    totalDebt: 'Ukupan dug',
    lastOrder: 'Zadnja narudžba',
    noOpenItemsForCustomerPermission: 'Nema otvorenih stavki za ovog kupca ili nemate dozvolu da ih vidite.',
    noSavedOrdersExact: 'Nema sačuvanih narudžbi',
    routeMapView: 'Prikaz rute na mapi',
    redMarker: 'red circle',
    readyToSend: 'Za slanje',
    pos: 'POS',
    freeInput: 'slobodan unos',
    paymentDelayDaysRequired: 'Odgoda plaćanja (dani) *',
    tobaccoDelayDaysRequired: 'Odgoda duhan (dani) *',
    unloadPlaceOrderRequired: 'Mjesto istovara = narudžba *',
    scan: 'Skeniraj',
    totalQuantityTitle: 'Ukupna Količina',
    successfullyScanned: 'Uspješno Skenirano',
    unknownStatusError: 'Greška! Nepoznat status.',
    discountClass: 'Klasa rabata',
    cancelAction: 'Poništi',
    reportRefreshHint: 'Pokušajte osvježiti stranicu ili odaberite manji vremenski period.',
    brandChartLimitHint: 'Za bolje performanse, grafik prikazuje samo prvih 50 brendova. Koristite datumski filter za manje podataka.',
    totalDailyRealization: 'Ukupna dnevna realizacija',
    totalTurnover: 'Ukupan promet',
    orderCount: 'Broj naloga',
    calculation: 'Obračun',
    documentNumber: 'Broj sa dok.',
    owes: 'Duguje',
    claims: 'Potražuje',
    balance: 'Saldo',
    totalOwes: 'Ukupno duguje',
    totalClaims: 'Ukupno potražuje',
    noItemsForSelectedCustomer: 'Nisu pronađene stavke za odabranog kupca.',
    selectCustomerPlaceholder: 'Odaberi kupca...',
    koStatus: 'Status KO',
    noOpenItemsExact: 'Nema otvorenih stavki',
    productSearch: 'Pretraga po artiklu',
    salesHistoryCroatianTitle: 'Povijest prodaje',
    noCustomersExact: 'Nema kupaca',
    customerSearch: 'Pretraga kupca',
    noCompletedSurveys: 'Nema popunjenih anketa',
    taskHistoryCroatianTitle: 'Povijest zadataka',
    enterYourComment: 'Unesite Vaš komentar...',
    taskExecutionOptionalInfo: 'Možete dodati dodatne informacije ili samo potvrditi izvršenje.',
    allCustomersAlreadyAssigned: 'Svi kupci su već dodijeljeni',
    noDocumentsExact: 'Nema dokumenata',
    taskNotFound: 'Zadatak nije pronađen',
    requestedTaskDoesNotExist: 'Traženi zadatak ne postoji',
  },
  additionalUi: {
    sessionExpired: 'Sesija je istekla. Osvježite prijavu i pokušajte ponovo.',
    authenticationError: 'Greška autentifikacije',
    unauthorizedOperation: 'Nemate ovlaštenje za ovu operaciju.',
    unauthorizedOperation403: 'Nemate ovlaštenje za ovu operaciju (403).',
    unknownError: 'Nepoznata greška',
    serverErrorWithCode: 'Greška na serveru ({{code}}). Pokušajte ponovo.',
    syncDataProgress: 'Sinhronizacija podataka ({{state}}) • {{elapsedTime}}',
    syncDataError: 'Greška prilikom sinhronizacije podataka • {{totalTime}}',
    syncFinishedWithErrors: 'Sinhronizacija završena sa greškama',
    syncFinishedSuccessfully: 'Sinhronizacija završena uspješno!',
    syncErrorWithMessage: 'Greška prilikom sinhronizacije: {{message}}',
    selectStoresForSync: 'Molimo odaberite barem jedan store za sinhronizaciju',
    syncSelectedStores: 'Sinhronizuj odabrano ({{count}})',
    syncOperationsCount: 'Sinhronizuj ({{count}} operacija)',
    syncSelectedCount: 'Sinhronizuj ({{count}})',
    selectWhatToSync: 'Odaberite šta želite sinhronizovati ({{count}})',
    selectWhatToSyncShort: 'Odaberi šta sinhronizovati:',
    syncingInProgress: 'Sinhronizacija u toku...',
    syncingShort: 'Sinhronizacija...',
    syncedCount: 'Uspješno ({{count}})',
    failed: 'Neuspjelo',
    retrySendError: 'Greška pri pokušaju ponovnog slanja.',
    deletedQueueItems: 'Obrisano {{count}} stavki iz reda čekanja.',
    deleteQueueError: 'Greška pri brisanju. Pokušajte ponovo.',
    noPendingActions: 'Nema akcija na čekanju',
    noPendingSyncActions: 'Nema akcija na čekanju za sinhronizaciju.',
    noUnhandledActionsForGroup: 'Nema neobrađenih akcija za ovu grupu.',
    ordersMissingOnServer: 'Narudžbe nisu stigle na server?',
    staleOperationsWarning: '{{count}} operacija čeka više od 4 dana. Sinhronizujte što prije da ne izgubite podatke.',
    noConnection: 'Nema veze',
    connectionError: 'Greška pri povezivanju',
    customerSelectedRepeatOrder: 'Kupac je odabran. Molimo dodajte artikle u korpu i završite narudžbu.',
    repeatOrderPrepareError: 'Greška prilikom pripremanja narudžbe za ponavljanje.',
    orderRepeatedSuccess: 'Narudžba je uspješno ponovljena!',
    offlineModeSynced: 'Offline režim (Sinhronizovano: {{count}})',
    selectFiltersForOrders: 'Molimo odaberite filtere za prikaz narudžbi.',
    noOfflineOrderData: 'Nema sačuvanih offline podataka za narudžbe.',
    noResultsForPeriod: 'Nema rezultata za odabrani vremenski period',
    noOrdersForPeriod: 'Nema narudžbi za odabrani vremenski period',
    noOfflineDataAvailable: 'Nema dostupnih offline podataka za prikaz.',
    localDataReadError: 'Greška pri čitanju lokalnih podataka.',
    userDoesNotUseLocation: 'Korisnik ne koristiti lokaciju',
    customerHasNoLocation: 'Kupac nema lokaciju',
    orderMapMarker: 'Narudžba',
    discount1: 'Rabat 1',
    discount2: 'Rabat 2',
    discount3: 'Rabat 3',
    dateCreated: 'Datum upisa',
    recordDate: 'Datum sloga',
    deliveryDateLabel: 'Datum isporuke',
    unloadingPlace: 'Mjesto isporuke',
    remoteVisit: 'Udaljena posjeta',
    invoice: 'Faktura',
    saveFrequentListsHint: 'Sačuvajte često korištene kombinacije artikala kao liste za brže naručivanje',
    listLoadPartial: 'Lista učitana: {{loaded}}/{{total}} artikala. {{unavailable}} artikala nije dostupno.',
    listLoadSuccess: 'Lista učitana: {{loaded}} artikala dodano u korpu',
    listLoadError: 'Greška pri učitavanju lista',
    listDeleted: 'Lista je obrisana',
    listDeleteError: 'Greška pri brisanju lista',
    savePlus: '+ Sačuvaj',
    noInternetTitle: 'Nema interneta',
    refreshAlreadyStarted: 'Osvježavanje je već pokrenuto nedavno. Molimo sačekajte još {{cooldown}} prije ponovnog pokušaja.',
    refreshAlreadyTried: 'Već ste pokušali da osvježite aplikaciju. Molimo sačekajte još {{cooldown}} prije ponovnog pokušaja.',
    refreshApplication: 'Osvježi aplikaciju',
    invalidEmailValidation: 'Unesite validnu email adresu',
    describeProblemValidation: 'Molimo opišite problem',
    uploadDocumentError: 'Greška kod slanja dokumenta na server: {{message}}',
    fetchDocumentsError: 'Greška pri preuzimanju dokumenata: {{message}}',
    cartDataError: 'Greška u podatcima korpe',
    photoUploadFailed: 'Neuspješno slanje fotografije',
    updatedProductsFetchError: 'Greška pri preuzimanju ažuriranih proizvoda: {{message}}',
    strapiUrlMissing: 'STRAPI_URL is not configured.',
    invalidImageFile: 'Invalid image file.',
    failedToReadFile: 'Failed to read the file.',
    compressionFailed: 'Compression failed: {{message}}',
    webpConversionFailed: 'Conversion to WebP failed.',
    requiredPassword: 'Molimo unesite password!',
    wrongPassword: 'Neispravna lozinka!',
  },
  sample: {
    word: 'Primjer',
    greeting: 'Pozdrav, {{name}}!',
  },
};

export default bs;
